import { useRouter } from 'next/navigation';
import useSWRMutation from 'swr/mutation';
import { useAuthStore as useOldAuthStore } from '@/src/stores/ModuleUserprofile';
import { authService } from '../services/auth';
import { useAddressStore } from '../stores/use-address-store';
import { useAuthStore } from '../stores/use-auth-store';
import { useIsAuthenticated } from './use-is-authenticated';

export function useLogout() {
  const router = useRouter();
  const oldAuthStore = useOldAuthStore();
  const isAuthenticated = useIsAuthenticated();
  const resetAuthStoreState = useAuthStore((state) => state.resetState);
  const resetAddressStoreState = useAddressStore((state) => state.resetState);

  const fetchKey = ['logout'];
  const { trigger, isMutating } = useSWRMutation(fetchKey, () => execute());

  const execute = async () => {
    if (!isAuthenticated) {
      router.push('/login');
      return;
    }

    await authService.destroySessionToken();
    oldAuthStore.logoutUser();
    resetAuthStoreState();
    resetAddressStoreState();
    router.push('/login');
  };

  return {
    trigger,
    isLoading: isMutating,
  };
}
